export const formatEditsPerPage = (totalEdits: number | undefined, totalPages: number | undefined) =>
  totalPages ? ((totalEdits || 0) / totalPages).toFixed(2) : '-';
